import { createFileRoute } from '@tanstack/react-router'
import Logout from '@/components/Logout'

function LogoutPage() {
  return <Logout />
}

export const Route = createFileRoute('/logout')({
  component: LogoutPage,
})
